export const BACKEND_URL = process.env.REACT_APP_BASE_URL

// tabs
export const tabs = ['Land Claim', 'Laboratory Checker', 'Trait Checker']

// traits
export const traitItems = ['background', 'base', 'eyes', 'outfit', 'mouth', 'headgear']